'use client';
import NewArrivals from '@c/newArrivals';
import HomeSection from 'features/homepage/components/Home/components/HomeSection';
import useMyFeed from 'features/homepage/hooks/useMyFeed';

export const HomeCuratedSection = () => {
  const { data: myFeed, isLoading } = useMyFeed();
  if (!myFeed?.recent?.length) return null;

  return (
    <HomeSection
      title="New Arrivals"
      subtitle="Curated for you."
      linkText="See All"
      href="/shop/recent"
      carouselWrapper
    >
      <NewArrivals
        products={myFeed.recent}
        isFetching={isLoading}
        smallProducts={false}
      />
    </HomeSection>
  );
};
